<template>
  <div>
    <div class="node-title">节点ID</div>
    <el-input disabled :value="value.id" />
    <div class="node-title">
      节点名称
      <span class="require">*</span>
    </div>
    <el-input
      :value="value.fullname"
      maxlength="20"
      show-word-limit
      @input="(e) => valueUpdate('fullname', e)"
    />
    <div class="node-title">备注描述</div>
    <el-input
      type="textarea"
      :rows="2"
      :value="value.description"
      @input="(e) => valueUpdate('description', e)"
      maxlength="50"
      autocomplete="off"
      placeholder="请输入"
    ></el-input>
    <div class="node-title">默认网关表达式「规则配置」（预算审批节点）</div>
    <el-select :value="defaultFormedExprId" placeholder="请选择" @change="updateDefaultFormedExpr">
      <el-option
        v-for="item in default_formed_expr_options"
        :key="item.id"
        :label="item.label"
        :value="item.id"
      ></el-option>
    </el-select>
    <div class="node-title">默认网关表达式「脚本内容」（预算审批节点）</div>
    <el-select
      :value="defaultExprContentId"
      placeholder="请选择"
      @change="updateDefaultExprContent"
    >
      <el-option
        v-for="item in default_expr_content_options"
        :key="item.id"
        :label="item.label"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    graph: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      default_formed_expr_options: [],
      default_expr_content_options: [],
      localDefaultFormedExprId: null,
      localDefaultExprContentId: null,
    };
  },
  computed: {
    defaultFormedExprId() {
      return (
        this.localDefaultFormedExprId ||
        (this.value.default_formed_expr_v1 && this.value.default_formed_expr_v1.id)
      );
    },
    defaultExprContentId() {
      return (
        this.localDefaultExprContentId ||
        (this.value.default_expr_content_v1 && this.value.default_expr_content_v1.id)
      );
    },
  },
  watch: {
    value: {
      handler(newVal) {
        // 同步本地状态与 props
        this.localDefaultFormedExprId =
          newVal.default_formed_expr_v1 && newVal.default_formed_expr_v1.id;
        this.localDefaultExprContentId =
          newVal.default_expr_content_v1 && newVal.default_expr_content_v1.id;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.updateOptionsFromEdges();
  },
  methods: {
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
    updateDefaultExprContent(e) {
      // 立即更新本地状态
      this.localDefaultExprContentId = e;
      this.localDefaultFormedExprId = null;

      this.valueUpdate('default_formed_expr_v1', undefined);
      const selectedOption = this.default_expr_content_options.find((item) => item.id === e);
      if (selectedOption) {
        this.valueUpdate('default_expr_content_v1', {
          id: selectedOption.id,
          value: selectedOption.value,
        });
      }
    },
    updateDefaultFormedExpr(e) {
      // 立即更新本地状态
      this.localDefaultFormedExprId = e;
      this.localDefaultExprContentId = null;

      const selectedOption = this.default_formed_expr_options.find((item) => item.id === e);
      if (selectedOption) {
        this.valueUpdate('default_formed_expr_v1', {
          id: selectedOption.id,
          value: selectedOption.value,
        });
      }
      this.valueUpdate('default_expr_content_v1', undefined);
    },
    updateOptionsFromEdges() {
      const { edges = [] } = this.graph.save() || {};
      const filterEdgesBySource = edges.filter((edge) => edge.source === this.value.id);

      this.default_expr_content_options = filterEdgesBySource
        .filter((edge) => edge.expr_content)
        .map((edge) => ({
          id: edge.id,
          label: edge.expr_name,
          value: edge.expr_content,
        }));

      this.default_formed_expr_options = filterEdgesBySource
        .filter((edge) => {
          const { formed_expr } = edge;
          return formed_expr?.conditionals?.some((condition) => condition.field !== '');
        })
        .map((edge) => ({
          id: edge.id,
          label: edge.expr_name,
          value: edge.formed_expr,
        }));
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/inputNumber.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/button.scss';

.node-title {
  margin-top: 8px;
  margin-bottom: 8px;
  color: #1c2028;
  font-weight: 700;
  .require {
    color: #e34d59;
  }
}
.time-inputbar {
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: #f6f7fb;
}
.intro-title {
  height: 40px;
  line-height: 40px;
  background: #f6f7fb;
  font-weight: 500;
  font-size: 14px;
  color: #667082;
  margin: 10px -10px 0;
  padding-left: 10px;
}
</style>
